var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"time":_vm.time,"color":_vm.type,"top":"","right":"","transition":"slide-x-reverse-transition"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("mdi- "+_vm._s(_vm.icon()))]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }